export default __webpack_public_path__ + "static/quickbase-footer-6b13766b8e50f434c69ce61b95d08f39.png";